import React from 'react';
import styles from './PaginationBlock.module.css'
import {useNavigate} from "react-router-dom";
import {observer} from "mobx-react-lite";

const PaginationBlock = observer(({route, count, current, setPageNumber}) => {
    const navigate = useNavigate();

    const pagIndexes = Array.from({length: count}, function (value, index) {
        return index;
    })

    const getNewPage = (number) => {
        setPageNumber(number);
        navigate(route + '?page=' + number);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }

    const createPagination = () => {
        return pagIndexes.map((index) => {
            const page = index + 1;

            if (index + 1 === current) {
                return (
                    <button
                        type="button"
                        className={`${styles.paginationItem} ${styles.active}`}
                        key={index}
                        aria-current="page"
                    >
                        {page}
                    </button>
                );
            } else {
                return (
                    <button
                        type="button"
                        className={styles.paginationItem}
                        onClick={() => getNewPage(page)}
                        key={index}
                    >
                        {page}
                    </button>
                );
            }
        })
    }

    return (
        <nav className={styles.pagination} aria-label="Пагинация">
            <button
                type="button"
                disabled={current === 1}
                className={styles.paginationItem}
                onClick={() => getNewPage(current - 1)}
                aria-label="Предыдущая страница"
            >
                ←
            </button>
            {createPagination()}
            <button
                type="button"
                disabled={current === count}
                className={styles.paginationItem}
                onClick={() => getNewPage(current + 1)}
                aria-label="Следующая страница"
            >
                →
            </button>
        </nav>
    );
});

export default PaginationBlock;
